import {InputSignal, Type} from "@angular/core";
import {LorenMeteringType} from "../loren-assets/interfaces/loren-metering-type";
import {ImageSensorCard} from "./image-sensor-card.component";
import {LorenMetering} from "../loren-assets/interfaces/loren-metering.interface";
import {LorenAsset} from "../loren-assets/interfaces/loren-asset.interface";
import {ImageSensorTable} from "./image-sensor-table.component";

export interface MetricComponentInputs {
    asset: InputSignal<LorenAsset>;
    metric: InputSignal<LorenMetering>;
}

interface MetricConfiguration {
    cardComponent: Type<MetricComponentInputs>;
    tableComponent: Type<MetricComponentInputs>;
}

export const MeticConfig: Partial<Record<LorenMeteringType, MetricConfiguration>> = {
    [LorenMeteringType.IMAGE_SENSOR]: {
        cardComponent: ImageSensorCard,
        tableComponent: ImageSensorTable,
    }
}